/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Monitoring API
 * Monitoring API for working with device errors
 *
 * The version of the OpenAPI document: 1.20.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Responses reason
 * @export
 * @enum {string}
 */
export enum ResponseReason {
    Ok = 'ok',
    Created = 'created',
    InvalidField = 'invalid_field',
    NoData = 'no_data',
    NotFound = 'not_found',
    NotImplemented = 'not_implemented',
    Restricted = 'restricted',
    ServerError = 'server_error'
}

